var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"SuplliersPage"},[_c('IllustrationBanner'),_c('div',{staticClass:"container"},[_c('h2',{staticClass:"color--primary"},[_vm._v(_vm._s(_vm.$t('suppliersPageHeading')))]),_c('SupplierList',{attrs:{"suppliers":_vm.suppliers}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }